"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Gallon = exports.MilliLiter = exports.Liter = exports.HundredCubicFeet = exports.CubicFeet = exports.CubicInch = exports.CubicCentiMeter = exports.CubicMeter = void 0;
var uom_1 = require("uom");
exports.CubicMeter = uom_1.UnitFormat.createUnitFormat("m³", 2);
exports.CubicCentiMeter = uom_1.UnitFormat.createUnitFormat("cm³", 2);
exports.CubicInch = uom_1.UnitFormat.createUnitFormat("in³", 2);
exports.CubicFeet = uom_1.UnitFormat.createUnitFormat("ft³", 0);
exports.HundredCubicFeet = uom_1.UnitFormat.createUnitFormat("100 ft³", 2);
exports.Liter = uom_1.UnitFormat.createUnitFormat("L", 2);
exports.MilliLiter = uom_1.UnitFormat.createUnitFormat("ml", 0);
exports.Gallon = uom_1.UnitFormat.createUnitFormat("gal", 1);
//# sourceMappingURL=volume-format.js.map